import { defer } from 'react-router-dom'
import { mercuryApi } from '$api'

// Defines what data should be loaded for this component, the data in here is
// fetched in parallel with navigating to the route and is then passed to the
// component as a prop.
export default async function loader({ params }) {
  const rulePackage = mercuryApi
    .get(`/pay-rules/packages/${params.packageId}`)
    .then((result) => {
      return result
    })

  const previousActivation = mercuryApi
    .get(`/pay-rules/packages/activate/${params.packageId}`)
    .then((result) => {
      return result
    })

  return defer({
    data: Promise.all([rulePackage, previousActivation]),
  })
}
